<search-box
  placeHolder="Search..."
  [searchCriteria]="searchCriteria"
  (searchCriteriaChanged)="updateSearchCriteria($event)"
  (showFilters)="openFilterDlg(filtersDlg, filters)"
>
</search-box>
<search-box-dlg #filtersDlg [delegate]="this" [filters]="filters">
  <manifest-filters #filters></manifest-filters>
</search-box-dlg>
